import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    supplier: {
        id: null,
        name: null,
        address: null,
        postal_code: null,
        city: null,
        country: null,
        outlet_id: null,
        region: null,
        contact_name: null,
        contact_no: null,
        contact_email: null,
        contact_fax: null,
        outlet: null,
        type: 'D',
        status: 1,
        shift_id: null,
    },
    supplierList: [],
};

const getters = {
    supplier: state => state.supplier,

    supplierList: state => state.supplierList,
};

const mutations = {
    [types.SET_SUPPLIER_ATTR](state, { key, value }) {
        state.supplier[key] = value;
    },

    [types.SET_SUPPLIER](state, supplier) {
        state.supplier = supplier;
    },

    setSupplierList(state, data) {
        state.supplierList = data;
    },

    setClearSupplier(state) {
        state.supplier = {
            id: null,
            name: null,
            address: null,
            postal_code: null,
            city: null,
            country: null,
            outlet_id: null,
            region: null,
            contact_name: null,
            contact_no: null,
            contact_email: null,
            contact_fax: null,
            outlet: null,
            type: 'D',
            status: 1,
            shift_id: null,
        };
    },
};

const actions = {
    async getSupplierList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('inventory.supplier.list');
        startLoading(dispatch, 'fetch-suppliers');

        const options = {
            params: Object.assign(
                {
                    query: '',
                    limit: 15,
                },
                params,
            ),
        };

        try {
            const { data } = await axios.get(url, options);
            commit('setSupplierList', data.data);
            endLoading(dispatch, 'fetch-suppliers');

            return data.data;
        } catch (e) {
            endLoading(dispatch, 'fetch-suppliers');
            throw e;
        }
    },

    async getSupplier({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.supplier.show', { id });
        startLoading(dispatch, 'fetch-supplier');

        try {
            const { data } = await axios.get(url);
            commit(types.SET_SUPPLIER, data);
            endLoading(dispatch, 'fetch-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-supplier');
            throw e;
        }
    },

    async createSupplier({ dispatch, state }) {
        startLoading(dispatch, 'save-supplier');
        const url = Laroute.route('inventory.supplier.create');

        try {
            const { data } = await axios.post(url, state.supplier);
            endLoading(dispatch, 'save-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-supplier');
            throw e;
        }
    },

    async updateSupplier({ commit, dispatch, state }) {
        startLoading(dispatch, 'save-supplier');

        const id = state.supplier.id;
        const url = Laroute.route('inventory.supplier.update');

        try {
            const { data } = await axios.put(url, state.supplier, id);
            commit(types.SET_SUPPLIER, data);
            endLoading(dispatch, 'save-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-supplier');
            throw e;
        }
    },

    async createSupplierStock({ dispatch, commit }, stock_id, cost) {
        startLoading(dispatch, 'save-supplier-stock');
        const url = Laroute.route('inventory.supplier.stock.add');

        try {
            const { data } = await axios.post(url, stock_id, cost);
            endLoading(dispatch, 'save-supplier-stock');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-supplier-stock');
            throw e;
        }
    },

    async saveSupplierStock({ dispatch, commit }, supplier_id, stock_id, cost) {
        startLoading(dispatch, 'update-supplier-stock');
        const url = Laroute.route('inventory.supplier.stock.update');

        try {
            const { data } = await axios.put(url, supplier_id, stock_id, cost);
            endLoading(dispatch, 'update-supplier-stock');

            return data;
        } catch (e) {
            endLoading(dispatch, 'update-supplier-stock');
            throw e;
        }
    },

    setSupplierAttr({ commit }, { key, value }) {
        commit(types.SET_SUPPLIER_ATTR, { key, value });
    },

    clearSupplier({ commit }) {
        commit('setClearSupplier');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-supplier.js